import {
  GET_VISITORS_DATA,
  GET_VISITOR_BY_ID,
  GET_VISITORS_IMPORT_STATUS,
  GET_VISITOR_RULES
} from './../constants/actionTypes'
import get from 'lodash/get'

export const visitors = (store = [], action = {}) => {
  switch (action.type) {
    case GET_VISITORS_DATA: {
      const page = get(action, 'data.page', {})
      const visitors =
        page.page === 1
          ? get(action, 'data.visitors', [])
          : [...get(store, 'visitors', []), ...get(action, 'data.visitors', [])]
      return {
        page,
        visitors
      }
    }
    default:
      return store
  }
}

export const visitorsImportStatus = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_VISITORS_IMPORT_STATUS:
      return action.data
    default:
      return store
  }
}

export const visitor = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_VISITOR_BY_ID:
      return action.data
    default:
      return store
  }
}

export const visitorRules = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_VISITOR_RULES:
      return action.data
    default:
      return store
  }
}
